/**
 * 海外路线开关的共用状态（14.39b）：路线设置页与**登录页内联行**同一份逻辑。
 *
 * 登录页也挂这个开关是刻意的（旧版 login_page 同样挂了）——默认域名被墙时根本
 * 登不进去，这是唯一自救口；所以本 hook 必须留在首屏 bundle 里（体积极小），
 * 且不依赖登录态（netRoute 切片不按 auth 门控，见 store/netRouteState.ts）。
 *
 * 零请求：读是纯全局库 kv；切换时 Worker 才发 1 次 GET /front/config（requests 注 19），
 * 切同值幂等不发。
 */
import { useCallback, useState } from 'preact/hooks';
import { routeRowView, ROUTE_ERROR_FALLBACK, type RouteRowView } from './routeSettingsModel';
import { netRouteConnection } from '~/store/appWorker';
import { loginErrorMessage } from '~/store/authActions';
import { useGlobal } from '~/store/useGlobal';

export interface RouteSwitchController {
  readonly view: RouteRowView;
  /** 上次切换的失败文案（成功/再次点击时清空） */
  readonly error: string;
  toggle(): void;
}

export function useRouteSwitch(): RouteSwitchController {
  const slice = useGlobal((s) => s.netRoute);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const toggle = useCallback(() => {
    if (slice === null || busy) return;
    setBusy(true);
    setError('');
    // 不乐观写：切片由 Worker 确认落位后回推（netRouteState.setOverseas）
    void netRouteConnection()
      .setOverseas(!slice.overseas)
      .then(
        () => setBusy(false),
        (e: unknown) => {
          setError(loginErrorMessage(e, ROUTE_ERROR_FALLBACK));
          setBusy(false);
        },
      );
  }, [slice, busy]);

  return { view: routeRowView(slice, busy, location.origin), error, toggle };
}
